module.exports = __webpack_public_path__ + "static/media/googleLogo.054c01a2.svg";